export class DefinicaoData {

    dataEscolhida: Date;
    link: string;
}